import 'swiper/swiper-bundle.css';
import {useAtom} from 'jotai';
import {useEffect, useRef} from 'react';
import {SwiperClass} from 'swiper/react';
import {selectedNearbyStoreItemCardAtom} from '@/map/atom';
import {Swiper, SwiperSlide} from '../Swiper';
import {StoreCard} from './Card';

export const StoreCards = ({hidden}: {hidden: boolean}) => {
  const [cards, setCards] = useAtom(selectedNearbyStoreItemCardAtom);
  const ref = useRef<SwiperClass>();

  const onSwiper = (swiper: SwiperClass) => {
    ref.current = swiper;
  };

  const handleChangeSlide = (swiper: SwiperClass) => {
    const index = swiper.realIndex;

    setCards((prev) => (prev ? {...prev, index} : null));
  };

  useEffect(() => {
    ref.current?.slideTo(cards?.index || 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cards?.items]);

  return (
    <Swiper
      hidden={hidden}
      onSwiper={onSwiper}
      onSlideChange={handleChangeSlide}
    >
      {cards?.items.map((i) => (
        <SwiperSlide key={i.branchName}>
          <StoreCard item={i} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};
